/**
 * Shared metadata for the public legal pages (Privacy Policy + Terms / EULA).
 * Keep contact + effective date in one place so both documents stay in sync.
 */
export const LEGAL_EFFECTIVE_DATE = "June 13, 2026";

/** Registered Washington LLC: legal operator of the Service (SOS filing name). */
export const LEGAL_ENTITY = "MS LEONARD LLC";

/** Consumer-facing brand / site name (DBA). */
export const LEGAL_BRAND = "Ms. Leonard";

/** Legal party in contracts and liability sections (same as entity). */
export const LEGAL_OPERATOR = LEGAL_ENTITY;

/** Washington Unified Business Identifier (assigned at LLC formation). */
export const LEGAL_UBI = "606 246 528";

/** Primary product / service name. */
export const LEGAL_SERVICE_NAME = "Code Create Slay";

/** App origin where the service lives. */
export const LEGAL_APP_ORIGIN = "code.msleonard.com";

/** Contact mailboxes referenced from the documents. */
export const LEGAL_PRIVACY_EMAIL = "privacy@msleonard.com";
export const LEGAL_SUPPORT_EMAIL = "support@msleonard.com";
